import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['active']

  declare readonly activeTarget: HTMLInputElement
  declare readonly hasActiveTarget: boolean

  save (e: Event): void {
    if (this.hasActiveTarget && !this.activeTarget.checked) return // need to confirm

    e.stopImmediatePropagation()

    this.submit_form()
  }

  private submit_form (): void {
    (this.element as HTMLFormElement).requestSubmit()
  }
}
